import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {

	return createStyles({
		subformInsuredInfoMailingAddress_yesNoBody: {
			padding: theme.spacing(3, 0),
		},
		subformInsuredInfoMailingAddress_sectionContainer: {
			padding: theme.spacing(2, 0),
		},
		subformInsuredInfoMailingAddress_sectionBody: {

		},
		subformInsuredInfoMailingAddress_sectionLabel: {
			color: theme.palette.info.main,
			fontWeight: theme.typography.fontWeightBold as any,
			fontSize: theme.typography.h5.fontSize,
		},
		subformInsuredInfoMailingAddress_addressContainer: {
			padding: theme.spacing(3, 0),
			width: '100%',
			display: 'flex',
			flexWrap: 'wrap',
		},
		subformInsuredInfoMailingAddress_addressBody: {
			padding: theme.spacing(0, 0),
			width: '100%',
		},
		subformInsuredInfoMailingAddress_addressLabel: {
			color: theme.palette.info.main,
			fontWeight: theme.typography.fontWeightBold as any,
			fontSize: theme.typography.h5.fontSize,
			margin: theme.spacing(0, 0, 4, 0),
		},
	});
});

export default useStyles;
